export const STAT_FILTERS = [
  ["Points", /Points/], ["Rebounds", /Rebounds/], ["Assists", /Assists|1\+ Assist/], ["3PM", /3PM/],
  ["Passing Yds", /Passing Yds/], ["Rushing Yds", /Rushing Yds/], ["Receiving Yds", /Receiving Yds/], ["Anytime TD", /Anytime TD/],
  ["Hits / Bases", /Hits|Total Bases/], ["Strikeouts", /Strikeouts/], ["RBI", /RBI/],
  ["Goals", /Goalscorer|Anytime Goal/], ["Shots", /Shots on/], ["Saves", /Saves/], ["Both Teams Score", /Both Teams/],
  ["Aces", /Aces/], ["Sets", /Set/], ["KO/TKO", /KO\/TKO/], ["Decision", /Decision/], ["Distance", /Distance/], ["Exacta", /Exacta/],
];

export const statsOf = (sgp) => {
  const set = new Set();
  sgp.legs.forEach((l) => STAT_FILTERS.forEach(([k, re]) => re.test(l.selection) && set.add(k)));
  return set;
};
